module.exports = __webpack_public_path__ + "img/funDeatil.c0f7eebf.png";